module.exports = "../../static/img/行业雷达icon.6642e86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpg/行业雷达icon.svg
// module id = ACz5
// module chunks = 1